import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var forgotPasswordRes;
export const forgotPasswordTodo = createAsyncThunk('forgotPassword', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'forgot_password',
            data: {
                "email": data?.values?.email,
            },
            headers: { "Content-Type": "application/json" }
        })
        return forgotPasswordRes = res

    } catch (error) {
        return forgotPasswordRes = error.response
    }
})